import { DownloadService } from './../../../downloads/download.service';
import { DownloadDialogModel } from './../../models/download-dialog-model.interface';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Option } from './../../../shared/model/option';
import { DownloadMethodEnum } from './../../../downloads/model/download-method-enum';
import { AudioFormatEnum } from './../../../downloads/model/audio-format-enum';
import { ProfileModelService } from './../../../profile/profile-model.service';
import {
  FormControl,
  Validators
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  public confirmMessage: string;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['name', 'download']

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private profileModelService: ProfileModelService,
    private downloadService: DownloadService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  formatOptions: Option<string>[] = [
    { name: AudioFormatEnum.MP3, value: AudioFormatEnum.MP3 },
    { name: AudioFormatEnum.AAC, value: AudioFormatEnum.AAC },
  ];
  formatOption = this.formatOptions[0];

  methodOptions: Option<string>[] = [
    { name: 'Direct Download', value: DownloadMethodEnum.DOWNLOAD },
    { name: 'E-mail', value: DownloadMethodEnum.EMAIL },
  ];
  methodOption = this.methodOptions[0];

  emailCtrl = new FormControl(null, [
    Validators.required,
    Validators.pattern(
      '^[A-Za-z0-9._%+-]+@[a-zA-Z0-9-]+\\.[A-Za-z]{1,3}[.]?[A-Za-z]{1,}$'
    ),
  ]);

  currentUserEmail: any;

  ngOnInit() {
    this.setDefaultUserEmail();
    this.dataSource = new MatTableDataSource<any>(this.data?.linksDownload?.map(link => {
      return { name: link, isLoading: false, view: link.split('.').pop().toUpperCase() };
    }));
  }

  setDefaultUserEmail() {
    this.currentUserEmail = this.profileModelService.getProfile().token;
    this.emailCtrl.setValue(this.currentUserEmail);
  }

  isEmail() {
    return this.methodOption.value === DownloadMethodEnum.EMAIL;
  }

  get disableSubmitButton() {
    return this.methodOption.value === DownloadMethodEnum.EMAIL && !this.emailCtrl.valid;
  }

  deliveryMethodClick() {
    if (!this.isEmail())
      this.setDefaultUserEmail();

  }

  submit() {
    this.dialogRef.close({
      deliveryMethodType: this.methodOption.value,
      formatType: this.formatOption.value,
      email: this.emailCtrl.value,
      downloadOption: "AUDIO"
    } as DownloadDialogModel)
  }

  callDownload(link) {
    link.isLoading = true;
    this.downloadFile(link);
  }

  private downloadFile(line) {
    const url = line.name;
    this.downloadService.downloadFile(url).subscribe(
      blobS3 => {
        const filename = url.substring(url.lastIndexOf('/') + 1);
        let blob = new Blob([blobS3], { type: blobS3.type });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        line.isLoading = false;

      });
  }
}


